import React, { useState } from "react";
import Button from "../Button";
import i18next from "i18next";
import { getSvgIcon } from "../../Helpers/get-assets";
import { Check, Share } from "react-feather";
import useGroupOrder from "../../global/useGroupOrder";
import useCopyToClipboard from "../../Helpers/hooks/useCopyToClipboard";
import QrCodePopup from "../QrCodePopup";
import GroupCartInfoPopup from "../GroupCartInfoPopup";
import NotificationPopup from "../Popup/NotificationPopup";

const GroupCartActions = () => {
    const qrIcon = getSvgIcon("share-qr.svg");
    const { inviteUrl, loading } = useGroupOrder();
    const [qrcodePopup, setQrcodePopup] = useState(false);
    const [infoPopup, setInfoPopup] = useState(false);
    const [copySuccessPopup, setSuccessCopy] = useState(false);

    const { copy } = useCopyToClipboard();

    const handleCopyToClipboard = async () => {
        const copySuccess = await copy(inviteUrl);
        setSuccessCopy(copySuccess);
    };

    if (loading) {
        return <div></div>;
    }

    return (
        <div id="group-cart-actions">
            <div className="group-cart-actions">
                <Button
                    onClick={() => setInfoPopup(true)}
                    variant="secondary"
                    size="XS"
                    label={i18next.t("groupCartInfo.edit")}
                />
                <button
                    onClick={() => setQrcodePopup(true)}
                    className="group-cart-actions__icon-btn">
                    <img src={qrIcon} />
                </button>
                <button
                    onClick={handleCopyToClipboard}
                    className="group-cart-actions__icon-btn">
                    <Share />
                </button>
            </div>
            <GroupCartInfoPopup
                open={infoPopup}
                setOpen={setInfoPopup}
                handleCopy={handleCopyToClipboard}
            />
            <QrCodePopup
                popupOpen={qrcodePopup}
                setOpen={setQrcodePopup}
                qrcode={inviteUrl}
            />
            <NotificationPopup
                open={copySuccessPopup}
                onClose={() => setSuccessCopy(false)}>
                <div className="create-grp-order__copy-success">
                    <div className="create-grp-order__copy-icon">
                        <Check />
                    </div>
                    <div className="create-grp-order__copy-info">
                        <span>{i18next.t("createGroupOrder.linkCopied")}</span>
                        <p>{i18next.t("createGroupOrder.shareLink")}</p>
                    </div>
                </div>
            </NotificationPopup>
        </div>
    );
};

export default GroupCartActions;
